import React from "react";
import NaviBar from "../../Component/Navbar";
import Container from "react-bootstrap/Container";

import TechStack from "./TechStack";
import Project_Bottom from "./Project_Bottom";

import './Project.css'

function Project() {

    return (
        <>
            <NaviBar></NaviBar>
            <div className={'project-bg'}>
                <Container className={'like-a-card'}>
                    <TechStack></TechStack>
                    <hr></hr>
                    <Project_Bottom></Project_Bottom>
                </Container>
            </div>
        </>
    )
}

export default Project;
